import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type UserProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function UserIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: UserProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M11.953 13.589h1.425a.777.777 0 00.744-1.037 4.566 4.566 0 00-4.078-2.634M10.044 8.08a2.443 2.443 0 002.443-2.443 2.442 2.442 0 00-2.443-2.45M9.35 14.385a1.272 1.272 0 001.024-2.023 5.351 5.351 0 00-4.148-2.132 5.35 5.35 0 00-4.148 2.132 1.272 1.272 0 001.024 2.023H9.35zM6.226 8.156a2.774 2.774 0 001.957-4.73A2.767 2.767 0 104.27 7.342c.519.52 1.223.813 1.957.814z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default UserIcon;
